import { useQuery } from '@tanstack/react-query';
import axios from 'axios';
import { Form, useNavigate, useParams } from 'react-router-dom';
import ServicesError from '../../components/ServicesError';
import { useApplicationStore } from '../../stores/applicationStore';
import ServiceCard from '../AvailableOrganizations/components/ServiceCard';

// Every service is linked to the org through its locations, so the org name
// comes back with the data rather than needing a separate lookup.
const organizationName = (programs) =>
	programs?.[0]?.locations?.[0]?.organization_name;

const OrganizationServices = () => {
	const { orgId } = useParams();
	const navigate = useNavigate();
	const { setProgram } = useApplicationStore();
	const {
		data: programs,
		isLoading,
		isError,
		refetch,
	} = useQuery({
		queryKey: ['organizationServices', orgId],
		queryFn: async () => {
			const { data } = await axios.get('/clients/services-by-org', {
				params: { orgId },
			});
			return data;
		},
	});

	// ServiceCard's Apply button is a submit button carrying the program id as its
	// value. Stash the chosen program, then let the Form navigate to /checkProfile.
	const handleSubmit = ({ nativeEvent }) => {
		const programId = nativeEvent.submitter.value;
		setProgram(programs.find((p) => p.id == programId));
	};

	return (
		<div className="page organization-services">
			<div className="sm:mx-auto sm:w-full sm:max-w-2xl">
				<h2>{organizationName(programs)}</h2>
				<h5>Organization Services</h5>
			</div>
			<div className="sm:mx-auto sm:w-full sm:max-w-2xl">
				<Form method="get" action="/checkProfile" onSubmit={handleSubmit}>
					{isLoading && (
						<div className="text-center">
							<span className="loading loading-dots loading-lg text-primary"></span>
						</div>
					)}
					{isError && <ServicesError onRetry={refetch} />}
					{!isLoading && !isError && programs.length === 0 && (
						<div>
							<p>No services found for this organization.</p>
							<button
								type="button"
								className="btn btn-primary btn-sm btn-block"
								onClick={() => navigate(-1)}
							>
								Go Back
							</button>
						</div>
					)}
					{!isLoading &&
						!isError &&
						programs.map((program) => (
							<ServiceCard
								key={program.id}
								program={program}
								programNameAsTitle
							/>
						))}
				</Form>
			</div>
		</div>
	);
};

export default OrganizationServices;
